import { createSlice } from "@reduxjs/toolkit";
import { factory } from "../../api/apiFactory";
const attendanceApi = factory.get("attendance");

const initialState = {
  team_leader_employee: {
    loading: false,
    data: [],
    total: 0,
    filters: {
      user_id: "",
      fingerprint_id: "",
      department_id: "",
      start_date: "",
      end_date: "",
    },
  },
};

export const teamleaderSlice = createSlice({
  name: "teamleader",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state[action.payload].loading = !state[action.payload].loading;
    },
    setData: (state, { payload }) => {
      state.team_leader_employee.data = payload.data.data;
      state.team_leader_employee.total = payload.data.total;
    },
    setFilters: (state, { payload }) => {
      state.team_leader_employee.filters = {
        ...state.team_leader_employee.filters,
        ...payload,
      };
    },
    resetFilters: (state) => {
      state.team_leader_employee.filters =
        initialState.team_leader_employee.filters;
    },
  },
});

export const { setLoading, setData, setFilters, resetFilters } =
  teamleaderSlice.actions;

export default teamleaderSlice.reducer;

//axios
const getAll = () => async (dispatch, getState) => {
  try {
    const filters = getState().attendance.hr_attendance.filters;
    dispatch(setLoading("team_leader_employee"));
    const res = await attendanceApi.getMyTeam(filters);
    dispatch(setData(res));
    dispatch(setLoading("team_leader_employee"));
  } catch (err) {
    dispatch(setLoading("team_leader_employee"));
    throw new Error(err);
  }
};

export const Teamleader = {
  getAll,
};
